export default "__VITE_PUBLIC_ASSET__2d284977__"